import React from 'react';
import PropTypes from 'prop-types';
import AuthenticatorWithEmail from 'utils/authentificator';

const AuthenticatorForm = (props) => {
  const { location: { state } } = props;

  return (
    <AuthenticatorWithEmail withRedirect recipe={state?.recipe} />
  );
};

AuthenticatorForm.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      recipe: PropTypes.shape({
        name: PropTypes.string,
        userId: PropTypes.string,
        ingredients: PropTypes.shape({
          condition: PropTypes.string,
          ingredient: PropTypes.string,
          themes: PropTypes.string
        })
      })
    })
  })
};

export default AuthenticatorForm;
